import { render, staticRenderFns } from "./OnRatiosTableCells.vue?vue&type=template&id=4d8fb94e&"
import script from "./OnRatiosTableCells.vue?vue&type=script&lang=js&"
export * from "./OnRatiosTableCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports